<template>
    <div class="seccion-datos">
        <h4><i class="fas fa-comments icono-simple"></i> Comentarios y Observaciones</h4>
        <div class="form-perfil">
            <div class="form-group full-width">
                <label><i class="fas fa-sticky-note"></i> Comentarios Internos</label>
                <textarea
v-if="isEditing" v-model="perfilEditado.internal_comments"
                    class="form-control textarea-large" placeholder="Comentarios internos del paciente" rows="3"></textarea>
                <p v-else class="form-value textarea-display">{{ perfilPaciente.internal_comments || 'Sin comentarios' }}
                </p>
            </div>
            <div class="form-group full-width">
                <label><i class="fas fa-comment-medical"></i> Feedback del Paciente</label>
                <textarea
v-if="isEditing" v-model="perfilEditado.patient_feedback"
                    class="form-control textarea-large" placeholder="Comentarios del paciente para el médico" rows="3"></textarea>
                <p v-else class="form-value textarea-display">{{ perfilPaciente.patient_feedback ||
                    'Sin comentarios del paciente' }}</p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, toRefs } from 'vue';

const props = defineProps({
    isEditing: {
        type: Boolean,
        default: false
    },
    perfilEditado: {
        type: Object,
        required: true
    },
    perfilPaciente: {
        type: Object,
        required: true
    }
});

const { isEditing, perfilEditado, perfilPaciente } = toRefs(props);
</script>

<style scoped>
.seccion-datos {
    margin-bottom: 2rem;
}

.seccion-datos h4 {
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 0.75rem;
}

.icono-simple {
    color: #3b82f6;
    font-size: 1.1rem;
}

.form-perfil {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.form-group label {
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: #64748b;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    gap: 0.35rem;
}

.form-group label i {
    font-size: 0.75rem;
    width: 0.85rem;
    text-align: center;
    color: #1e40af;
}

.form-value {
    font-size: 0.925rem;
    font-weight: 500;
    color: #1e293b;
    padding: 0.5rem 0;
    margin-top: 0;
    border: none;
    border-bottom: 1px solid rgba(15, 23, 42, 0.1);
    background: transparent;
    line-height: 1.4;
    letter-spacing: 0.15px;
    min-height: 2rem;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
}

.form-value:hover {
    border-bottom-color: rgba(30, 64, 175, 0.25);
    color: #0f172a;
}

.form-value:empty::before {
    content: "Sin registro";
    color: #cbd5e1;
    font-weight: 400;
    font-style: italic;
    font-size: 0.875rem;
}

.textarea-large {
    min-height: 90px;
}

.textarea-display {
    white-space: pre-line;
}

@media (max-width: 768px) {
    .form-perfil {
        gap: 1rem;
    }
}
</style>
